import Rectangle from "./Rectangle";
import Length from "./Length";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class Trapezoid extends AbstractShape {
	static NAME = "trapezoid";

	constructor( width_bottom, offset_left, width_top, height ) {
		super();

		this.width_bottom = width_bottom;
		this.offset_left = offset_left;
		this.width_top = width_top;
		this.height = height;
	}

	get_name() {
		return Trapezoid.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.width_top.max( this.width_bottom ), this.height );
	}

	get_area() {
		return new Area( ( this.width_bottom.in_mm() + this.width_top.in_mm() ) / 2 * this.height.in_mm() );
	}

	get_circumference() {
		const left_diagonal = Math.sqrt( Math.pow( this.offset_left.in_mm(), 2 ) + Math.pow( this.height.in_mm(), 2 ) );
		const offset_right = this.width_bottom.subtract( this.width_top.add( this.offset_left ) );
		const right_diagonal = Math.sqrt( Math.pow( offset_right.in_mm(), 2 ) + Math.pow( this.height.in_mm(), 2 ) );
		return this.width_bottom.add( this.width_top ).add( new Length( left_diagonal ) ).add( new Length( right_diagonal ) );
	}

	get_width_bottom() {
		return this.width_bottom;
	}

	get_width_top() {
		return this.width_top;
	}

	get_offset_left() {
		return this.offset_left;
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width_bottom: maximum_rectangle.get_longest_side(),
			offset_left: maximum_rectangle.get_longest_side(),
			width_top: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_longest_side()
		};
	}

	get_dimension_keys() {
		return ["width_top", "height", "width_bottom", "offset_left"];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width_bottom: this.width_bottom.in_mm(),
			offset_left: this.offset_left.in_mm(),
			width_top: this.width_top.in_mm(),
			height: this.height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Trapezoid( new Length( primitives.width_bottom ), new Length( primitives.offset_left ), new Length( primitives.width_top ), new Length( primitives.height ) );
	}

}
